export const ISetConfigurationUseCaseType = Symbol('ISetConfigurationUseCase');
